import { ICellRendererParams } from "ag-grid-enterprise";
import { X } from "lucide-react";
import React from "react";

import { IgIconButton } from "@intelligems/ig-theme/IgIconButton";
import { GenericCenteredContainer } from "@src/components/MainApp/SharedProductPicker/list/containers";
import { useDispatch } from "@src/store";
import { toggleProduct } from "@src/store/slices/productPicker";
import { ProductPickerSelectedProduct } from "@src/store/slices/productPicker/types";

export const ProductListDeleteButton = ({
  data,
}: ICellRendererParams<ProductPickerSelectedProduct>) => {
  const dispatch = useDispatch();
  const onClick = () => {
    if (data) {
      dispatch(toggleProduct(data));
    }
  };
  return (
    <GenericCenteredContainer>
      <IgIconButton onClick={onClick}>
        <X size={14} />
      </IgIconButton>
    </GenericCenteredContainer>
  );
};
